/*global _ */
import Vue from 'vue';

export default {
collapseHotspot: (state, data) => {
    const index = _.findIndex(state.interactionMetas, im => im.interactionId === data.interactionId);
    state.interactionMetas[index].collapsed = data.value;
  },
setEditFreeResponse: (state) => {
  state.editFreeResponseState = !state.editFreeResponseState;
}, 
appendEditFreeResponse: (state, interactionId) => {
  const index = _.findIndex(state.interactionAttempts, ia => ia.interactionId === interactionId);
  Vue.set(state.interactionAttempts[index], 'isSetEditFreeResponse', state.editFreeResponseState);
},
setInteractionGroups: (state, groups) => state.interactionGroups = groups,
  setInteractionStates: (state) => {
    let interactionStates = [];
    if (state.interactions) {
      state.interactions.forEach(interaction => {
        interactionStates.push({
          interaction: _.assign({}, _.cloneDeep(state.defaultInteraction), _.find(state.interactions, i => i.id === interaction.id) || {}),
          interactionAttempt: _.assign({}, _.cloneDeep(state.defaultInteractionAttempt), _.find(state.interactionAttempts, ia => ia.interactionId === interaction.id) || {}),
          interactionMeta: _.assign({}, _.cloneDeep(state.defaultInteractionMeta), _.find(state.interactionMetas, im => im.interactionId === interaction.id) || {})
        });
      });
    }
    state.interactionStates = _.sortBy(interactionStates, is => is.interaction.displayInTime);
  },
  setRubricSubmitting: (state, val) => state.rubricSubmitting = val,
  setRubricSubmitted: (state, val) => state.rubricSubmitted = val,
  setOldDiscussionComments: (state, oldDiscussionComments) => state.oldDiscussionComments = oldDiscussionComments,
  updateActiveInteraction: (state, activeInteraction) => {
    state.activeInteraction = activeInteraction;
  },
  updateAllInteractions: (state, interactions) => state.interactions = interactions,
  updateAllInteractionAttempts: (state, interactionAttempts) => state.interactionAttempts = interactionAttempts,
  updateAllInteractionMetas: (state, interactionMetas) => state.interactionMetas = interactionMetas,
  upsertInteraction: (state, interaction) => {
    // console.log('upsertInteraction', interaction);
    const index = _.findIndex(state.interactions, i => i.id === interaction.id);
    if (index > -1) {
      Vue.set(state.interactions, index, _.assign({}, state.interactions[index], interaction));
    } else {
      state.interactions.push(interaction);
    };
  },
  upsertInteractionAttempt: (state, interactionAttempt) => {
    const index = _.findIndex(state.interactionAttempts, ia => ia.interactionId === interactionAttempt.interactionId);
    if (index > -1) {
      Vue.set(state.interactionAttempts, index, _.assign({}, state.interactionAttempts[index], interactionAttempt));
    } else {
      state.interactionAttempts.push(interactionAttempt);
    };
  },
  upsertReplaceInteractionAttempt: (state, interactionAttempt) => {
    const index = _.findIndex(state.interactionAttempts, ia => ia.interactionId === interactionAttempt.interactionId);
    if (index > -1) {
      Vue.set(state.interactionAttempts, index, interactionAttempt);
    } else {
      state.interactionAttempts.push(interactionAttempt);
    };
  },
  updateHotspotPositionsArray: (state, value) => {
      state.hotspotPositionsArray.push(value);
  },
  upsertInteractionMeta: (state, interactionMeta) => {
    // console.log('upsertInteractionMeta', interactionMeta);
    const index = _.findIndex(state.interactionMetas, im => im.interactionId === interactionMeta.interactionId);
    if (index > -1) {
      // console.log('upsertInteractionMeta', interactionMeta);
      Vue.set(state.interactionMetas, index, _.assign({}, state.interactionMetas[index], interactionMeta));
    } else {
      state.interactionMetas.push(interactionMeta);
    };
  },
  updateInteractionRequired: (state, data) => {
    // Get interaction index of required interaction
    const index = _.findIndex(state.interactions, i => i.id === data.interactionId);
    if (index >= 0) {
      state.interactions[index].isRequired = data.isRequired;
      if (state.interactions[index].interactionType === 'discussion_q' && !state.dummyCommentSubmitted) state.interactionMetas[index].isInteractionAnswered = false;
    }
  },
  updateInteractionMetaPastSessionTime: (state, data) => {
    // Get interactionMeta index of interaction
    const index = _.findIndex(state.interactionMetas, im => im.interactionId === data.interactionId);
    if (index >= 0) {
      state.interactionMetas[index].pastSessionTime = data.pastSessionTime;
    }
  },
  updateInteractionMetaPastInteractionOffset: (state, data) => {
    // Get interactionMeta index of interaction
    const index = _.findIndex(state.interactionMetas, im => im.interactionId === data.interactionId);
    if (index >= 0) {
      state.interactionMetas[index].pastInteractionOffset = data.pastInteractionOffset;
    }
  },
  updateDummyCommentSubmitted: (state, value) => {
    state.dummyCommentSubmitted = value;
  },
  setDiscussionInteractionHasCommentReplies: (state, value) => {
    state.discussionInteractionHasCommentReplies = value;
  },
  setDiscussionCommentsShowReplies: (state, value) => {
    const index = state.discussionCommentsShowReplies.findIndex( (e) => e.commentId === value.commentId);
    if (index === -1) {
      state.discussionCommentsShowReplies.push(value);
    } else {
      Vue.set(state.discussionCommentsShowReplies, index, value);
    }
  },
  setInteractionContinueButtonShouldBeHidden: (state, value) => state.interactionContinueButtonShouldBeHidden = value,
}